import { useEffect } from "react"

import CreditMeter from "./credit_meter"
import UpgradeCreditsButton from "./upgrade_credits_button"
import { spentPercentage } from "./utils/credits"
import { CreditsBalance } from "shared/utils/credits"
import requestExtraCredits from "app/utils/extra_credits_request"
import { trackExtraCreditsRequestShown, TrackExtraCreditsRequestPayload } from "app/utils/mixpanel_tracking"

import styles from "./out_of_credits_banner.module.scss"

interface Props {
  balance: CreditsBalance
  // Absent on the top credits plan, which has nothing left to buy.
  onUpgrade?: () => void
  // Only on the top credits plan: it offers a support conversation instead.
  extraCreditsRequest?: TrackExtraCreditsRequestPayload
}

const OutOfCreditsBanner = ({ balance, onUpgrade, extraCreditsRequest }: Props) => {
  useEffect(() => {
    if (extraCreditsRequest) trackExtraCreditsRequestShown(extraCreditsRequest)
  }, [])

  return (
    <div className={styles["out-of-credits-banner"]}>
      <CreditMeter filled={spentPercentage(balance)} onDark>
        <div className={styles.headline}>
          <span className={styles.title}>Out of credits</span>
          <span className={styles.count}>
            {balance.remaining}/{balance.total} left
          </span>
        </div>
        <span className="body-caption">
          You can still create and connect this Applet, but it will be paused until your credits renew
          {onUpgrade ? " or you upgrade." : "."}
        </span>
      </CreditMeter>
      {onUpgrade && <UpgradeCreditsButton onClick={onUpgrade} onDark />}
      {extraCreditsRequest && (
        <UpgradeCreditsButton
          onClick={() => requestExtraCredits(extraCreditsRequest)}
          onDark
          label="Talk to us for more credits"
        />
      )}
    </div>
  )
}

export default OutOfCreditsBanner
